import { useEffect } from "react";
import "./Clientes.css";
import nc1 from '../../img/nc_assis_locacoes.png';
import nc3 from '../../img/nc_cardiovita.png';
import nc4 from '../../img/nc_cemig.png';
import nc5 from '../../img/nc_ecofire.png';
import nc6 from '../../img/nc_hb.png';
import nc7 from '../../img/nc_jard.png';
import nc8 from '../../img/nc_mundoBan.png';
import nc9 from '../../img/nc_pref_dt.png';
import nc10 from '../../img/nc_pref_er.png';
import nc11 from '../../img/nc_pref_pr.png';
import nc12 from '../../img/nc_pref_re.png';
import nc13 from '../../img/nc_wow.png';


function Clientes() {

    useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("fade-in");
            }
        });
    }, { threshold: 0.1 });

    // Agora observamos o título e os cartões de clientes
    document.querySelectorAll(".title, .card-cliente").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
}, []);


    return (
        <div className="container-inicial container-clientes" id="clientes">
  <h1 className="numeros-titulo title">Nosso Clientes</h1>
  <div className="cards-clientes">
    <div className="card-cliente"><img src={nc1} alt="Logotipo da empresa Assis Locações" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc3} alt="Logotipo da empresa Cardiovita" loading="lazy" /></div>
    <div className="card-cliente cemig"><img src={nc4} alt="Logotipo da CEMIG - Companhia Energética de Minas Gerais" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc5} alt="Logotipo da empresa Ecofire" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc6} alt="Logotipo da empresa HB" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc7} alt="Logotipo da empresa Jardim das Palmeiras" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc8} alt="Logotipo da empresa Mundoban Locações" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc9} alt="Logotipo da Prefeitura Municipal de Dores do Turvo" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc10} alt="Logotipo da Prefeitura Municipal de Entre Rios de Minas" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc11} alt="Logotipo da Prefeitura Municipal de Prados" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc12} alt="Logotipo da Prefeitura Municipal de Rio Espera" loading="lazy" /></div>
    <div className="card-cliente"><img src={nc13} alt="Logotipo da empresa WOW" loading="lazy" /></div>
  </div>
</div>

    );
}

export default Clientes;
